export interface ResolveClosedWaitlistRedirectOptions {
	venueId: string
	slug?: string | null
	language: string
	search?: string
	referrer?: string
	hubBaseUrl?: string
	reservationWidgetUrl?: string
}

export function isHubOrigin(
	originParam?: string | null,
	hubUrlParam?: string | null,
	referrer?: string
): boolean {
	const origin = (originParam || '').toLowerCase()
	return (
		origin === 'hub' ||
		origin.includes('hub.') ||
		Boolean(hubUrlParam) ||
		Boolean(referrer && /hub\.(tagme\.com\.br|beta\.tagme\.com\.br|staging\.tagme\.com\.br)/i.test(referrer)) ||
		Boolean(referrer && referrer.includes('localhost:4003'))
	)
}

export function resolveClosedWaitlistRedirectUrl(
	options: ResolveClosedWaitlistRedirectOptions
): string {
	const search =
		options.search !== undefined
			? options.search
			: typeof window !== 'undefined'
			? window.location.search
			: ''
	const searchParams = new URLSearchParams(search)
	const originParam = searchParams.get('origin')
	const hubUrlParam = searchParams.get('hubUrl')
	const referrer =
		options.referrer !== undefined
			? options.referrer
			: typeof document !== 'undefined'
			? document.referrer
			: ''

	if (isHubOrigin(originParam, hubUrlParam, referrer)) {
		if (hubUrlParam && /^https?:\/\//i.test(hubUrlParam)) {
			return hubUrlParam
		}

		if (originParam && /^https?:\/\//i.test(originParam)) {
			return originParam
		}

		if (referrer && /^https?:\/\/[^/]*hub\./i.test(referrer)) {
			return referrer
		}

		const hubBase = (
			options.hubBaseUrl ||
			process.env.REACT_APP_HUB_URL ||
			'https://hub.tagme.com.br'
		).replace(/\/$/, '')
		const venueSlugOrId = options.slug || options.venueId
		return `${hubBase}/${venueSlugOrId}`
	}

	const smartlinkLang = options.language === 'pt' ? 'pt-br' : options.language
	const reservationWidgetUrl = (
		options.reservationWidgetUrl ||
		process.env.REACT_APP_RESERVATION_WIDGET_URL ||
		'https://reservation-widget.tagme.com.br'
	).replace(/\/$/, '')
	return `${reservationWidgetUrl}/smartlink/${options.venueId}?lng=${smartlinkLang}`
}
